export default "__VITE_ASSET__21c20f1f__"